<template>
  <div class="goods-post">
    <div class="wall">
      <div class="wall-head">新增福利品</div>
      <div class="mt-40 ml-20 post-form">
        <el-form ref="form" :model="form" label-width="80px">
          <rs-form-item label="活动名称" prop="name" required>
            <el-input v-model="form.name"></el-input>
          </rs-form-item>

          <rs-form-item label="活动图" prop="image" required>
            <uploader v-model="form.image" :height="375" :width="750" />
          </rs-form-item>

          <rs-form-item label="活动时间" prop="date" required>
            <el-date-picker
              class="w-100"
              v-model="form.date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </rs-form-item>

          <rs-form-item label="产品" required>
            <div>
              <div v-for="(item, index) in productList" :key="index" class="d-flex product-item">
                <img :src="item.product.picture" alt="" class="product-img">
                <div class="flex-body ml-20 product-body">
                  <div class="clamp">{{ item.product.title }}</div>
                  <div>¥ {{ item.sku.shop_price }}</div>
                  <div class="mt-auto color-sliver flex-between">
                    <small>{{ item.sku.specs|obj_to_string }}</small>
                    <div class="flex-inline">
                      <el-button size="mini" icon="el-icon-minus" @click="quantityReduce(index)"/>
                      <div class="ml-5 mr-5">{{ item.quantity }}</div>
                      <el-button size="mini" icon="el-icon-plus" @click="quantityAdd(index)"/>
                    </div>
                  </div>
                  <i class="el-icon-close color-sliver" @click="handleRemove(index)"></i>
                </div>
              </div>
              <el-button size="mini" @click="showProductSelect">选择</el-button>
            </div>
          </rs-form-item>

          <rs-form-item label="库存" prop="stock" required>
            <el-input v-model="form.stock"></el-input>
          </rs-form-item>

          <rs-form-item label="售价" prop="price" required>
            <el-input v-model="form.price"></el-input>
          </rs-form-item>

          <rs-form-item label="服务">
            <el-input v-model="form.serve"></el-input>
          </rs-form-item>

          <rs-form-item class="mt-40">
            <el-button type="primary" size="small" round @click="onSubmit">保存</el-button>
            <el-button size="small" round @click="$router.go(-1)">取消</el-button>
          </rs-form-item>
        </el-form>
      </div>
    </div>

    <product-select-modal ref="productSelect" @on-select="handleSelect"/>
  </div>
</template>

<script>
import Uploader from '@/components/Uploader';
import ProductSelectModal from '@/components/ProductSelectModal';

export default {
  components: {
    Uploader,
    ProductSelectModal
  },
  data() {
    return {
     form: {},
     productListObj: {},
     productList: []
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return false
      })
    },
    handleSelect(product, sku) {
      let key = product.id + '-' + sku.id
        let sotck = sku.stock;
      if (Object.prototype.hasOwnProperty.call(this.productListObj, key)) {
        if (this.productListObj[key].quantity >= sotck) {
          this.$message.error('库存不足')
          return false;
        }
        this.productListObj[key].quantity += 1;
      } else {
        if (1 > sotck) {
          this.$message.error('库存不足')
          return false;
        }
        this.productListObj[key] = {
          key,
          quantity: 1,
          product,
          sku
        }
      }
      this.productList = Object.values(JSON.parse(JSON.stringify(this.productListObj)))
    },
    // 移除商品
    handleRemove(index) {
      let key = this.productList[index].key;
      delete this.productListObj[key];
      this.productList.splice(index, 1);
    },

    // 减少数量
    quantityReduce(index) {
      let key = this.productList[index].key;
      let quantity = this.productListObj[key].quantity;
      if (quantity == 1) return false
      quantity -= 1
      this.productListObj[key].quantity = quantity
      this.productList[index].quantity = quantity

    },
    // 增加数量
    quantityAdd(index) {
      let key = this.productList[index].key;
      let quantity = this.productListObj[key].quantity;
      let sotck = this.productList[index].sku.stock;
      if (quantity >= sotck) {
        this.$message.error('库存不足')
        return false;
      }

      quantity += 1

      this.productListObj[key].quantity = quantity
      this.productList[index].quantity = quantity
    },
    showProductSelect() {
      this.$refs.productSelect && this.$refs.productSelect.show()
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-post {
  .post-form {
    max-width: 480px;
  }
  .product-item {
    padding: 5px 10px;
    border: 1px solid #f5f5f5;
    border-radius: 7px;
    margin-bottom: 7px;
    .product-img {
      height: 80px;
      width: 80px;
      border-radius: 7px;
    }
    .product-body {
      position: relative;
      .clamp {
        padding-right: 20px;
      }
      width: 220px;
      height: 100%;
      .el-icon-close {
        position: absolute;
        top: 5px;
        right: 0px;
        &:hover {
          cursor: pointer;
        }
      }
      ::v-deep .el-button--mini {
        padding: 3px 5px;
      }
    }
  }
}
</style>